import React from 'react';
import '../../index.scss';
import {
    chipForGap,
    scalePct,
} from '../../constants';
import { scaleScores } from '../../../../../../../../utils/scaleConfig';

const formatDelta = (gap) => {
    const sign = gap > 0 ? '+' : gap < 0 ? '−' : '';
    return `${sign}${Math.abs(gap).toFixed(2)}`;
};

const DumbellChart = (props) => {
    const { scale } = props;
    // Whole-number ticks across the scale (1..6 or 1..4).
    const ticks = scaleScores(scale);
    // The mint "healthy zone" band highlights the favorable top of the scale.
    const bandLeft = scalePct(scale.favorableThreshold, scale);
    const bandWidth = scalePct(scale.max, scale) - bandLeft;

    return (
        <>
            {/* Header: category label, the numbered axis, and the delta title */}
            <div className='divergence__header'>
                <span className='divergence__head-category'>Category</span>
                <div className='divergence__axis'>
                    <span
                        className='divergence__band'
                        style={{ left: `${bandLeft}%`, width: `${bandWidth}%` }}
                    />
                    {ticks.map((tick) => (
                        <span
                            key={tick}
                            className='divergence__tick'
                            style={{ left: `${scalePct(tick, scale)}%` }}
                        >
                            {tick}
                        </span>
                    ))}
                </div>
                <span className='divergence__head-delta'>&Delta; Self &minus; Others</span>
            </div>

            {/* One row per category */}
            <div className='divergence__rows'>
                {props.divergenceData.map((row) => {
                    const gap = row.gap
                    const chip = chipForGap(row.severity);
                    const selfPct = scalePct(row.self, scale);
                    const othersPct = scalePct(row.others, scale);
                    const connectorLeft = Math.min(selfPct, othersPct);
                    const connectorWidth = Math.abs(selfPct - othersPct);

                    return (
                        <div className='divergence__row' key={row.category}>
                            <div className='divergence__category'>
                                <span className='divergence__category-name'>{row.category}</span>
                                <span className='divergence__category-meta'>
                                    Self {row.self.toFixed(2)} &middot; Others {row.others.toFixed(2)}
                                </span>
                            </div>

                            <div className='divergence__plot'>
                                <span
                                    className='divergence__band'
                                    style={{ left: `${bandLeft}%`, width: `${bandWidth}%` }}
                                />
                                <span
                                    className='divergence__connector'
                                    style={{ left: `${connectorLeft}%`, width: `${connectorWidth}%` }}
                                />
                                <span
                                    className='divergence__marker divergence__marker--others'
                                    style={{ left: `${othersPct}%` }}
                                    title={`Others ${row.others.toFixed(2)}`}
                                />
                                <span
                                    className='divergence__marker divergence__marker--self'
                                    style={{ left: `${selfPct}%` }}
                                    title={`Self ${row.self.toFixed(2)}`}
                                />
                            </div>

                            <span className={`divergence__chip divergence__chip--${chip.modifier}`}>
                                {chip.label}
                            </span>

                            <span className='divergence__delta'>{formatDelta(gap)}</span>
                        </div>
                    );
                })}
            </div>

            {/* Footer: legend + the coaching-threshold note */}
            <div className='divergence__footer'>
                <div className='divergence__legend'>
                    <span className='divergence__legend-item'>
                        <span className='divergence__dot divergence__dot--self' />
                        Self
                    </span>
                    <span className='divergence__legend-item'>
                        <span className='divergence__dot divergence__dot--others' />
                        All But Self
                    </span>
                </div>
                <span className='divergence__note'>
                    Gaps of 0.30 or more typically warrant a coaching conversation.
                </span>
            </div>
        </>
    );
};

export default DumbellChart;
